export const EMOJI_SETS = {
  default: {
    sad:     '😔',
    anxious: '😟',
    calm:    '😌',
    happy:   '😊',
    excited: '🤩',
    book:    '📚',
    note:    '📝',
    star:    '⭐',
    check:   '✓',
    plant:   '🌿',
    walk:    '🚶',
    music:   '🎵',
    heart:   '💚',
  },
  rainy: {
    sad:     '/images/icons/rainy/sad.png',
    anxious: '/images/icons/rainy/anxious.png',
    calm:    '/images/icons/rainy/calm.png',
    happy:   '/images/icons/rainy/happy.png',
    excited: '/images/icons/rainy/excited.png',
    book:    '/images/icons/rainy/book.png',
    note:    '/images/icons/rainy/note.png',
    star:    '/images/icons/rainy/star.png',
    check:   '/images/icons/rainy/check.png',
    plant:   '/images/icons/rainy/plant.png',
    walk:    '/images/icons/rainy/walk.png',
    music:   '/images/icons/rainy/music.png',
    heart:   '/images/icons/rainy/heart.png',
  },
  cafe: {
    sad:     '/images/icons/cafe/sad.png',
    anxious: '/images/icons/cafe/anxious.png',
    calm:    '/images/icons/cafe/calm.png',
    happy:   '/images/icons/cafe/happy.png',
    excited: '/images/icons/cafe/excited.png',
    book:    '/images/icons/cafe/book.png',
    note:    '/images/icons/cafe/note.png',
    star:    '/images/icons/cafe/star.png',
    check:   '/images/icons/cafe/check.png',
    plant:   '/images/icons/cafe/plant.png',
    walk:    '/images/icons/cafe/walk.png',
    music:   '/images/icons/cafe/music.png',
    heart:   '/images/icons/cafe/heart.png',
  },
  quest: {
    sad:     '/images/icons/quest/sad.png',
    anxious: '/images/icons/quest/anxious.png',
    calm:    '/images/icons/quest/calm.png',
    happy:   '/images/icons/quest/happy.png',
    excited: '/images/icons/quest/excited.png',
    book:    '/images/icons/quest/book.png',
    note:    '/images/icons/quest/note.png',
    star:    '/images/icons/quest/star.png',
    check:   '/images/icons/quest/check.png',
    plant:   '/images/icons/quest/plant.png',
    walk:    '/images/icons/quest/walk.png',
    music:   '/images/icons/quest/music.png',
    heart:   '/images/icons/quest/heart.png',
  },
  general: {
    sad:     '/images/icons/general/sad.png',
    anxious: '/images/icons/general/anxious.png',
    calm:    '/images/icons/general/calm.png',
    happy:   '/images/icons/general/happy.png',
    excited: '/images/icons/general/excited.png',
  },
}
